import script from "./SettingsChangelogSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsChangelogSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsChangelogSection.vue?vue&type=style&index=0&id=1ed73bef&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed73bef"]])

export default __exports__